/**
 * @Author Valon.Ye
 * @Date 2022/06/15 15:54:54
 * @FilePath \business\src\components\Loading\index.tsx
 * @Description
 */
/**
 * @summary 如果会闪的话，就不要加fillByParent， 老老实实给父容器加 position: relative
 */
import { memo, useRef, useEffect } from 'react'
import Spinner from '@salesforce/design-system-react/components/spinner'

import type { FC, CSSProperties } from 'react'

type ILoadingProps = {
  fillByParent?: boolean
  id?: string
  size?: 'xx-small' | 'x-small' | 'small' | 'medium' | 'large'
  loading?: boolean
  containerStyle?: CSSProperties
  containerClassName?: string
  variant?: FCProps<typeof Spinner>['variant']
}

const Loading: FC<ILoadingProps> = memo(
  ({ fillByParent = false, children, id, loading, ...rest }) => {
    const idRef = useRef<string>(id || Math.random().toString(32).substr(2))
    const parentRef = useRef<HTMLDivElement | null>()

    useEffect(() => {
      if (!idRef.current) return
      let originalPositionStyle = ''
      if (!parentRef.current) {
        const loadingDOM = document.getElementById((idRef.current as unknown) as string)
        if (!loadingDOM) return
        parentRef.current = loadingDOM?.parentNode?.parentNode as HTMLDivElement
        originalPositionStyle = parentRef.current.style.position
      }
      if (fillByParent) {
        parentRef.current.style.position = loading ? 'relative' : originalPositionStyle || ''
      }
      // eslint-disable-next-line consistent-return
      return () => {
        if (parentRef.current) {
          parentRef.current!.style.position = originalPositionStyle
          parentRef.current = null
        }
      }
    }, [idRef.current, loading, fillByParent])

    return (
      <>
        {loading && <Spinner id={idRef.current} variant="brand" {...rest} />}
        {children}
      </>
    )
  },
)

export type { ILoadingProps }

export default Loading
